const normalize = (value) => {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z\s-]/g, '')
    .replace(/[-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const levenshteinDistance = (a, b) => {
  if (a === b) return 0;
  if (!a) return b.length;
  if (!b) return a.length;

  const matrix = Array.from({ length: a.length + 1 }, () => []);

  for (let i = 0; i <= a.length; i += 1) matrix[i][0] = i;
  for (let j = 0; j <= b.length; j += 1) matrix[0][j] = j;

  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1,
        matrix[i][j - 1] + 1,
        matrix[i - 1][j - 1] + cost
      );
    }
  }

  return matrix[a.length][b.length];
};

const thresholdFor = (value) => {
  if (value.length <= 4) return 1;
  if (value.length <= 7) return 2;
  return 3;
};

export const isFuzzyMatch = (guess, targetName) => {
  const normalizedGuess = normalize(guess);
  const normalizedTarget = normalize(targetName);

  if (!normalizedGuess || !normalizedTarget) return false;

  if (normalizedGuess === normalizedTarget) return true;

  const targetTokens = normalizedTarget.split(' ');
  if (targetTokens.includes(normalizedGuess)) return true;

  const maxDistance = thresholdFor(normalizedGuess);
  if (levenshteinDistance(normalizedGuess, normalizedTarget) <= maxDistance) return true;

  return targetTokens.some((token) => {
    if (token.length < 3) return false;
    return levenshteinDistance(normalizedGuess, token) <= thresholdFor(token);
  });
};
